export default __webpack_public_path__ + "static/28-479b8c527417402ea32ad348479a416e.png";